import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { rgba } from 'polished';
import styled from 'styled-components';
const Container = styled.div `
  position: relative;
  display: block;
  width: auto;
`;
const Input = styled.input `
  ${fonts.apparat.light};

  display: block;
  appearance: none;
  border: 1px solid ${brand.base.blue};
  border-radius: 0;
  color: ${brand.base.blue};
  font-size: ${fluid(16, 18)};
  height: ${fluid(45, 54)};
  padding: 0 ${fluid(12, 24)};
  width: 100%;

  &::placeholder {
    ${fonts.apparat.light};

    color: ${rgba(brand.base.blue, 0.5)};
  }

  &[data-error='true'] {
    border-color: ${brand.validation.invalid};
  }

  &:disabled {
    cursor: not-allowed;
    background-color: ${brand.white};
  }

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-width: 2px;
    outline-style: solid;
  }
`;
export const Icon = styled.span `
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  display: block;
  height: 20px;
  width: 20px;

  @media ${from(Device.Tablet)} {
    height: 24px;
    width: 24px;
  }
`;
const Error = styled.span `
  display: block;
  color: ${brand.validation.invalid};
  font-size: 14px;
  letter-spacing: -0.02em;
  line-height: 16px;
  margin: 8px 0 0 0;
`;
export default {
    Container,
    Error,
    Icon,
    Input,
};
